import request from '../utils/request';
import qs from "qs";

export const queryXmOrders = param => {
	return request.get('/api/topUp/queryPublicAccountOrders?code=' + param.code + '&&openId=' + param.openId)
};
export const getOpenId = param => {
	return request.post('/api/topUp/getOpenId', qs.stringify(param))
};

export const getXmInfo = param => {
	return request.post('/api/topUp/publicAccountTopUp', qs.stringify(param))
};

export const getPhonePackageInfo = phone => {
	return request.post('/api/dxt/packageTopUp/phoneInfo', qs.stringify({ phone }))
};

export const publicAccountPackageTopUp = param => {
	return request.post('/api/dxt/packageTopUp/publicAccountPackageTopUp', qs.stringify(param))
};
